<style>
  table {
    margin-top: 30px;
    width: 100%;
    font-size: 13px;
  }

  thead {
    background: none;
  }

  tr {
    height: 36px;
  }
</style>

<div style="background: #F5F5F5; padding: 16px;">
  <div class="row page-title-bar" style="margin-bottom: 16px;">
    <div class="medium-12 title scenarios">
      <span
        style="display: inline-block;width:20%;text-overflow: ellipsis;white-space: nowrap;overflow: hidden;">{{clientTaxPlan.name || ''}}</span>
      <span class="float-right scenario-dropdown" style="display: block;width: 15%;">
        <label>
          <app-tpiq-select-dropdown (onValueSelect)="filterClientPlan($event)" [includeNone]="false"
                                    [setData]="clientPlans"
                                    [setDefaultValue]="clientTaxPlan.id" [setPlaceHolder]="'Select Plan'"
                                    [setSearchKey]="'name'" [setValueKey]="'id'"></app-tpiq-select-dropdown>

        </label>
      </span>
      <span class="float-right">
        <button (click)="showStatusWarning('publish')" *ngIf="hasStrategies && clientTaxPlan.status !== 'publish'" class="button"
                style="margin-bottom: 0">Publish</button>
        <button (click)="showStatusWarning('unpublish')" *ngIf="hasStrategies && clientTaxPlan.status === 'publish'" class="button"
                style="margin-bottom: 0">Unpublish</button>
        <button (click)="closePeriodOfPlan()" class="button" style="margin-bottom: 0">Close Year</button>
        <button (click)="freezeOrUnfreezePlan('archive', closeYearPlanName)" *ngIf="!freezPlan" class="button"
                style="margin-bottom: 0">Archive</button>
        <button (click)="freezeOrUnfreezePlan('unarchive', closeYearPlanName)" *ngIf="freezPlan" class="button"
                style="margin-bottom: 0">Unarchive</button>
      </span>
      <span (click)="view1040Document()" *ngIf="clientTaxPlan.documentId" class="float-right pointer view-1040-doc">
        <img src="../../../images/core-focus/external-link.png"/><u class="text">View 1040 PDF</u>
      </span>
    </div>
  </div>
  <div class="row">
    <div class="medium-12">
      <div class="tax-strategy">
        <div class="reports" foundation>
          <div class="row">
            <div class="medium-12 columns" style="padding: 0;">
              <ul class="reports tabs" data-tabs id="report-tabs" style="background: #F5F5F5;padding: 0;">

                <!-- Date : 8 Aug 2025 (Comment the Features,  Feature name :  Projection Asst (tax_estimates)) -->
                 <!-- dev : Ishan batish -->


                 <li *ngIf="estimatesAccess && projectionAsstEnabled"
                    [ngClass]="{'is-active': currentView == 'tax_estimates'}"
                    class="reports tabs-title">
                  <a (click)="switchPage('tax_estimates')" aria-selected="false" id="a-tax_estimates">
                    <h6>Projection Asst</h6>
                  </a>
                </li>
                <li *ngIf="!estimatesAccess && projectionAsstEnabled" [ngClass]="{'is-active': currentView == 'tax_estimates'}"
                    class="reports tabs-title">
                  <a style="cursor: auto"><h6>
                <span class="text-center badge-tooltip">
                  <span>Projection Asst</span>
                  <span class="bottomTooltiptext" style="width: 175px; margin-left: -85px;">Upgrade to access!</span>
                </span>
                  </h6></a>
                </li>
                <li [ngClass]="{'is-active': currentView == 'client_plan'}" class="reports tabs-title"><a
                  (click)="switchPage('client_plan')" aria-selected="false" id="a-client_plan"><h6>Plan details &
                  Strategies</h6></a></li>
                <li [ngClass]="{'is-active': currentView == 'roi_page'}" class="reports tabs-title"><a (click)="switchPage('roi_page')"
                                                                                                       aria-selected="false"
                                                                                                       id="a-roi_page">
                  <h6>Return on Investment</h6></a></li>
                <li *ngIf="presentationAccess" [ngClass]="{'is-active': currentView == 'roi_presentation'}"
                    class="reports tabs-title"><a (click)="switchPage('roi_presentation')"
                                                                                    aria-selected="false"
                                                                                    id="a-roi_presentation"><h6>
                  Presentation</h6></a></li>
                <li *ngIf="!presentationAccess" [ngClass]="{'is-active': currentView == 'roi_presentation'}"
                    class="reports tabs-title">
                  <a style="cursor: auto"><h6>
                <span class="text-center badge-tooltip">
                  <span>Presentation</span>
                  <span class="bottomTooltiptext" style="width: 175px; margin-left: -85px;">Upgrade to access!</span>
                </span>
                  </h6></a>
                </li>
                <li [ngClass]="{'is-active': currentView == 'roi_dashboard'}" class="reports tabs-title"><a
                  (click)="switchPage('roi_dashboard')" aria-selected="false" id="a-roi_dashboard"><h6>Report</h6></a>
                </li>

                 <!-- Date : 8 Aug 2025 (Comment the Features,  Feature name :  Timeline (cashflow_timeline)) -->
                 <!-- dev : Ishan batish -->

                <!-- <li [ngClass]="{'is-active': currentView == 'cashflow_timeline'}" class="reports tabs-title"><a
                  (click)="switchPage('cashflow_timeline')" aria-selected="false" id="a-cashflow_timeline"><h6>
                  Timeline</h6></a></li> -->
              </ul>
            </div>
            <div class="medium-12 columns invoices scenarios new-input-fields" style="padding: 0;">
              <ng-template [ngIf]="currentView == 'roi_page' && (isPaidPlan || userReadOnly)">
                <div class="row tabs-content">
                  <div class="medium-12 column mt-1 mb-2" style="display: flex;">
                    <div class="roi-filter" style="flex: 2.5">
                      <span style="position: relative;top: 10px;">
                        <span style="padding-right: 10px;"><input (change)="setValuesForFilterOptions()" [(ngModel)]="planFilterOptions.actual"
                                                                  class="pointer"
                                                                  type="checkbox"/> Actual Savings</span>
                        <ng-template [ngIf]="planFilterOptions.actual">
                          <span style="padding-right: 10px;"><input [(ngModel)]="planFilterOptions.dollarChange" [checked]="planFilterOptions.dollarChange"
                                                                    class="pointer"
                                                                    type="checkbox"/> $Change</span>
                          <span><input [(ngModel)]="planFilterOptions.percentageChange" [checked]="planFilterOptions.percentageChange" class="pointer"
                                       type="checkbox"/> %Change</span>
                        </ng-template>
                      </span>
                    </div>
                    <div class="roi-filter" style="flex: 1;margin-right: 15px;">
                      <app-tpiq-select-dropdown (onValueSelect)="filterROIPage($event)" [includeNone]="false"
                                                [setData]="filterYears"
                                                [setDefaultValue]="roiFilterYear" [setPlaceHolder]="'Year'"
                                                [setSearchKey]="'name'"
                                                [setValueKey]="'id'"></app-tpiq-select-dropdown>
                    </div>
                    <div class="roi-filter badge-tooltip" style="flex: 1;margin-right: 15px;">
                      <app-tpiq-select-dropdown (onValueSelect)="setView($event)" [includeNone]="false"
                                                [setData]="views"
                                                [setDefaultValue]="'Category'" [setPlaceHolder]="'Select View'"
                                                [setSearchKey]="'name'"
                                                [setValueKey]="'name'"></app-tpiq-select-dropdown>
                      <span class="bottomTooltiptext" style="min-width: 200px; font-size: 12px;">
                        Select the ROI view filters that best fits your needs to present to your client
                      </span>
                    </div>
                    <ng-template [ngIf]="!userReadOnly">
                      <div class="roi-filter badge-tooltip" style="flex: 1.3;margin-right: 15px;">
                        <span style="position: relative;top: 10px;">
                          <input (click)="setDefaultYearForROI()" [(ngModel)]="roiDefaultYear" [disabled]="roiDefaultYear"
                                 type="checkbox"/>
                          <span style="color: #878787; padding-left: 10px">Default to this year</span>
                        </span>
                      </div>
                      <div class="roi-filter badge-tooltip" style="flex: 1;margin-right: 15px;">
                        <span style="position: relative;top: 10px;">
                          <input [(ngModel)]="displayLogo" type="checkbox"/>
                          <span style="color: #878787; padding-left: 10px">Display Logo</span>
                        </span>
                      </div>
                      <div class="badge-tooltip roi-export-buttons" style="flex: 1;margin-top: 5px;">
                        <button type="button" class="button" style="margin-bottom: 0; white-space: nowrap;" (click)="exportToPDF('roi_page')">Download PDF</button>
                        <button type="button" class="button" style="margin-bottom: 0; white-space: nowrap;" (click)="exportToExcel('roi_page')">Download Excel</button>
                      </div>
                    </ng-template>
                  </div>
                  <div class="columns medium-12">
                    <div class="reports" data-tabs-content="report-tabs" foundation>
                      <div *ngIf="hasROIData" class="reports tabs-panel is-active" id="roi" style="padding: 0;">
                        <app-roi-page (triggerToRefreshRoiData)="refreshRoiData($event)" (navigateToAddFees)="onNavigateToAddFees()" [bgColor]="bgColor" [displayLogo]="displayLogo"
                                      [filterOptions]="planFilterOptions" [readOnly]="userReadOnly"
                                      [roiData]="roiData" [taxPlanId]="taxStrategyId"
                                      [taxYear]="roiFilterYear" [hasActualAmount] = "hasActualAmount" ></app-roi-page>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </div>
          </div>
          <div *ngIf="(currentView == 'roi_page' || currentView == 'roi_dashboard' || currentView == 'roi_presentation' || currentView == 'cashflow_timeline') && (currentPlan.toLowerCase().includes('pay-per-tax-plan') && !isPaidPlan && !userReadOnly)"
               style="padding: 35px;text-align: center;">
            <div>Please purchase this plan to produce the ROI, Presentation, Report, Timeline, and Tasks.</div>
            <div style="font-size: 14px;margin-top: 5px;">For more information <a href="https://www.taxplaniq.com/pay-per-plan"
                                                                                  style="text-decoration: underline;"
                                                                                  target="_blank">click here</a>.
            </div>
            <div style="display: flex;margin-top: 10px;">
              <div style="flex: 2;padding-right: 3rem;">
                <button (click)="confirm()" class="button small mt-4" style="float: right;">Pay</button>
              </div>
              <div style="flex: 2;padding-left: 3rem;border-left: 2px solid #475467;">
                <div style="text-align: left;">Have a coupon code?</div>
                <div style="margin-top: 1rem;">
                  <input [(ngModel)]="couponCode" placeholder="Enter coupon here..." style="width: 40%;float: left;"
                         type="text"/>
                  <div>
                    <button (click)="applyCoupon()" class="button small" style="float: left;margin-left: 2rem;">Apply
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="couponSuccess" style="display: flex;">
              <div style="flex: 2;padding-right: 3rem;"></div>
              <div class="bold" style="flex: 2;padding-left: 3rem;color: green;text-align: left;font-size: 12px;">Coupon
                applied successfully.
              </div>
            </div>
          </div>
          <div class="reports" data-tabs-content="report-tabs">
            <div *ngIf="currentView == 'client_plan'" class="reports tabs-panel is-active" id="plan"
                 style="padding: 0;">
              <div class="row">
                <div class="column medium-12" style="margin-bottom: 10px;">
                  <span class="float-right">
                    <span (click)="toggleNotes()" [ngClass]="showNotes? 'plan-info-tab-selected' : ''"
                          class="pointer icon-gap">
                      <span><i class="material-icons manage-strategy-icon">edit</i></span>
                      <span>Notes</span>
                    </span>
                    <span (click)="toggleRates()" [ngClass]="showRates? 'plan-info-tab-selected' : ''"
                          class="pointer icon-gap">
                      <span><i class="material-icons manage-strategy-icon">edit</i></span>
                      <span>Rates</span>
                    </span>
                    <span (click)="toggleCostLines()" [ngClass]="showCostLines? 'plan-info-tab-selected' : ''"
                          class="pointer icon-gap">
                      <span><i class="material-icons manage-strategy-icon">edit</i></span>
                      <span>Fees</span>
                    </span>

                    <!-- Date : 8 Aug 2025 (Comment the Features,  Feature name :  Timeline (cashflow_timeline)) -->
                    <!-- dev : Ishan batish -->

                    <!-- <span (click)="toggleCashflow()" [ngClass]="showCashflow? 'plan-info-tab-selected' : ''"
                          class="pointer icon-gap">
                      <span><i class="material-icons manage-strategy-icon">edit</i></span>
                      <span>Cashflow</span>
                    </span> -->
                    <span (click)="showTemplates()" [ngClass]="reveal['showTemplates']? 'plan-info-tab-selected' : ''"
                          class="pointer icon-gap">
                      <span><i class="material-icons manage-strategy-icon">visibility</i></span>
                      <span>Templates</span>
                    </span>
                  </span>
                </div>
                <div class="column medium-12" style="padding: 0;">
                  <div class="reports" data-tabs-content="report-tabs">
                    <div *ngIf="showRates" class="reports tabs-panel is-active" id="rates" style="padding: 0;"
                         style="background: #fefefe;margin-bottom: 10px;">
                      <div class="strategy-line" style="padding: 10px;">
                        <div class="row">
                          <div class="column medium-12 large-12">
                            <span (click)="showRates = false" class="pointer float-right">
                              <i class="icon ion-ios-close-outline manage-strategy-icon"></i>
                            </span>
                          </div>
                        </div>
                        <div class="row">
                          <div class="medium-3 column ">
                            <div class="rate-section">
                              <div class="text-center">
                                Total Tax
                              </div>
                              <div *ngIf="!editing['totalTax']" class="text-center total-color pointer">
                                {{clientTaxPlan.totalTax| formatAmount:'$0,0'}}
                                <span (click)="toggleField('totalTax', true)" *ngIf="!freezPlan && !userReadOnly"
                                      class="material-icons pointer edit-rate-icon">edit</span>
                              </div>
                              <div *ngIf="editing['totalTax']" class="text-center editing">
                                <label class="editing-label float-left">
                                  <input [(ngModel)]="temp['totalTax']" [format]="'$0,0.00'" [locale]="'usd'"
                                         model-numeral placeholder="Total Tax" type="text"/>
                                </label>
                                <span (click)="updateValue('totalTax')" class="material-icons pointer icon float-left">done</span>
                                <span (click)="revertValue('totalTax')" class="material-icons pointer icon float-left">clear</span>
                              </div>
                            </div>
                          </div>
                          <div class="medium-3 column">
                            <div class="rate-section">
                              <div class="text-center">
                                Taxable Income
                              </div>
                              <div *ngIf="!editing['taxableIncome']" class="text-center total-color pointer">
                                {{clientTaxPlan.taxableIncome| formatAmount:'$0,0'}}
                                <span (click)="toggleField('taxableIncome', true)" *ngIf="!freezPlan && !userReadOnly"
                                      class="material-icons pointer edit-rate-icon">edit</span>
                              </div>
                              <div *ngIf="editing['taxableIncome']" class="text-center editing">
                                <label class="editing-label float-left">
                                  <input [(ngModel)]="temp['taxableIncome']" [format]="'$0,0.00'" [locale]="'usd'"
                                         model-numeral placeholder="Taxable Income" type="text"/>
                                </label>
                                <span (click)="updateValue('taxableIncome')"
                                      class="material-icons pointer icon float-left">done</span>
                                <span (click)="revertValue('taxableIncome')"
                                      class="material-icons pointer icon float-left">clear</span>
                              </div>
                            </div>
                          </div>
                          <div class="medium-3 column">
                            <div class="rate-section">
                              <div class="text-center">
                                Effective Rate
                              </div>
                              <div *ngIf="!editing['effectiveRate']" class="text-center total-color pointer">
                                <span *ngIf="showEffectiveRate()">{{clientTaxPlan.effectiveRate}} %</span>
                                <span *ngIf="!showEffectiveRate()">n/m (business loss)</span>
                                <span (click)="toggleField('effectiveRate', true)" *ngIf="!freezPlan && !userReadOnly"
                                      class="material-icons pointer edit-rate-icon">edit</span>
                              </div>
                              <div *ngIf="editing['effectiveRate']" class="text-center editing">
                                <label class="editing-label float-left">
                                  <input [(ngModel)]="temp['effectiveRate']" [format]="'0,0.00'" [locale]="'usd'"
                                         model-numeral placeholder="Effective Rate" type="text"/>
                                </label>
                                <span (click)="updateValue('effectiveRate')"
                                      class="material-icons pointer icon float-left">done</span>
                                <span (click)="revertValue('effectiveRate')"
                                      class="material-icons pointer icon float-left">clear</span>
                              </div>
                            </div>
                          </div>
                          <div class="medium-3 column">
                            <div class="rate-section">
                              <div class="text-center">
                                Marginal Rate
                                <span class="text-center badge-tooltip">
                                <i (click)="showRatesInfo()" class="icon ion-ios-information-outline"></i>
                                <span class="bottomTooltiptext" style="width: 250px; margin-left: -85px;">
                                  Click here to link to current marginal tax rates
                                </span>
                              </span>
                              </div>
                              <div *ngIf="!editing['marginalRate']" class="text-center total-color pointer">
                                {{clientTaxPlan.marginalRate}} %
                                <span (click)="toggleField('marginalRate', true)" *ngIf="!freezPlan && !userReadOnly"
                                      class="material-icons pointer edit-rate-icon">edit</span>
                              </div>
                              <div *ngIf="editing['marginalRate']" class="text-center editing">
                                <label class="editing-label float-left">
                                  <input [(ngModel)]="temp['marginalRate']" [format]="'0,0'" [locale]="'usd'"
                                         model-numeral placeholder="Marginal Rate" type="text"/>
                                </label>
                                <span (click)="updateValue('marginalRate')"
                                      class="material-icons pointer icon float-left">done</span>
                                <span (click)="revertValue('marginalRate')"
                                      class="material-icons pointer icon float-left">clear</span>
                              </div>
                            </div>
                          </div>
                          <div class="medium-3 column">
                            <div class="rate-section">
                              <div class="text-center">
                                Cap Gain Rate
                                <span class="text-center badge-tooltip">
                                <i (click)="showRatesInfo()" class="icon ion-ios-information-outline"></i>
                                <span class="bottomTooltiptext" style="width: 250px; margin-left: -85px;">
                                  Click here to link to current cap gains tax rates
                                </span>
                              </span>
                              </div>
                              <div *ngIf="!editing['capGainRate']" class="text-center total-color pointer">
                                {{clientTaxPlan.capGainRate}} %
                                <span (click)="toggleField('capGainRate', true)" *ngIf="!freezPlan && !userReadOnly"
                                      class="material-icons pointer edit-rate-icon">edit</span>
                              </div>
                              <div *ngIf="editing['capGainRate']" class="text-center editing">
                                <label class="editing-label float-left">
                                  <input [(ngModel)]="temp['capGainRate']" [format]="'0,0'" [locale]="'usd'"
                                         model-numeral placeholder="Cap Gain Rate" type="text"/>
                                </label>
                                <span (click)="updateValue('capGainRate')"
                                      class="material-icons pointer icon float-left">done</span>
                                <span (click)="revertValue('capGainRate')"
                                      class="material-icons pointer icon float-left">clear</span>
                              </div>
                            </div>
                          </div>
                          <div class="medium-3 column">
                            <div class="rate-section">
                              <div class="text-center">
                                C Corp Flat Rate
                              </div>
                              <div *ngIf="!editing['ccropFlatRate']" class="text-center total-color pointer">
                                {{clientTaxPlan.ccropFlatRate}} %
                                <span (click)="toggleField('ccropFlatRate', true)" *ngIf="!freezPlan && !userReadOnly"
                                      class="material-icons pointer edit-rate-icon">edit</span>
                              </div>
                              <div *ngIf="editing['ccropFlatRate']" class="text-center editing">
                                <label class="editing-label float-left">
                                  <input [(ngModel)]="temp['ccropFlatRate']" [format]="'0,0'" [locale]="'usd'"
                                         model-numeral placeholder="CCorp Flat Rate" type="text"/>
                                </label>
                                <span (click)="updateValue('ccropFlatRate')"
                                      class="material-icons pointer icon float-left">done</span>
                                <span (click)="revertValue('ccropFlatRate')"
                                      class="material-icons pointer icon float-left">clear</span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="medium-12 columns">
                            <hr/>
                          </div>
                        </div>
                        <div class="row">
                          <div class="column medium-12 large-12">
                            <button (click)="addNewCustomRate()" *ngIf="!freezPlan && !userReadOnly"  [disabled]="tempCustomTaxRates && tempCustomTaxRates.length > 0"
                                    class="button tiny float-right" style="margin-right: 10px;">Add
                            </button>
                          </div>
                        </div>
                        <div class="row">
                          <div *ngFor="let customRate of clientTaxPlan.customTaxRates;let index = index;"
                               class="medium-3 column">
                            <div class="rate-section">
                              <div *ngIf="!editing[index]" class="text-center editing">
                                <span>{{customRate.name}}</span>
                                <span *ngIf="customRate.formula && customRate.formula.type" class="text-center badge-tooltip"
                                      style="z-index: 3 !important;">
                                <i (click)="showStateRatesInfo(customRate.formula.type)"
                                   class="icon ion-ios-information-outline"></i>
                                <span class="bottomTooltiptext" style="width: 250px; margin-left: -85px;">
                                  Click here to link to current {{customRate.formula.type}} state rates
                                </span>
                              </span>
                              </div>
                              <div *ngIf="!editing[index]" class="text-center total-color pointer" style="clear: both;">
                                <span>{{customRate.rate}} %</span>
                                <span
                                  (click)="showEditForCustomRate(customRate)"
                                  *ngIf="!freezPlan && !userReadOnly && customRate.formula && customRate.formula.displayValue !== customRate.formula.actualValue"
                                  class="material-icons pointer edit-rate-icon">edit</span>
                                <span
                                  (click)="toggleField(index, true, customRate)"
                                  *ngIf="!freezPlan && !userReadOnly && customRate.formula && customRate.formula.displayValue === customRate.formula.actualValue"
                                  class="material-icons pointer edit-rate-icon">edit</span>
                                <span
                                  *ngIf="!freezPlan && !userReadOnly &&(customRate.formula && !customRate.formula.type)"><i
                                  (click)="deleteCustomRate(index)" class="icon ion-ios-trash-outline"
                                  style="color: #F06459;"></i></span>
                              </div>
                              <div *ngIf="editing[index]" class="text-center editing d-flex align-items-center gap-1">
                                <label *ngIf="customRate.formula && !customRate.formula.type"
                                       class="editing-label px-2 mb-1">
                                  <input [(ngModel)]="tempNames[index]" placeholder="Rate name" type="text"/>
                                </label>
                                <label *ngIf="customRate.formula && customRate.formula.type"
                                       class="editing-label float-left">{{tempNames[index]}}</label>
                              </div>
                              <div *ngIf="editing[index]" class="text-center editing d-flex align-items-center gap-1 px-2">
                                <label class="editing-label pe-1">
                                  <input [(ngModel)]="temp[index]" [format]="'0,0'" [locale]="'usd'"
                                         model-numeral placeholder="{{customRate.name}}" type="text"/>
                                </label>
                                <span (click)="updateValue(index, true)" class="material-icons pointer icon mt-0">done</span>
                                <span (click)="revertValue(index)"
                                      class="material-icons pointer icon mt-0">clear</span>
                                <span class="badge-tooltip"
                                      style="position: relative;"><span
                                  class="pointer"><i (click)="showEditForCustomRate(customRate)"
                                                                class="icon ion-ios-calculator-outline"></i><span
                                  class='bottomTooltiptext tpActionTooltip'
                                  style="font-size: 13px !important;width: 150px !important;">Build your formula</span></span></span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div *ngFor="let tempCustomRate of tempCustomTaxRates;let index = index;" class="row editing">
                          <div class="medium-3 columns">
                            <input [(ngModel)]="tempCustomRate.name" placeholder="Enter Custom Rate Name" type="text"/>
                          </div>
                          <div class="medium-1 columns">
                            <input [(ngModel)]="tempCustomRate.rate" [format]="'0,0'" [locale]="'usd'" model-numeral
                                   type="text"/>
                          </div>
                          <div class="medium-1">
                            <span style="position: relative;top: 8px;">(OR)</span>
                            <span class="badge-tooltip"><span style="position: relative;top: 8px;padding-left: 15px;"><i
                              (click)="openFormulaCalculator(tempCustomRate, index)" class="icon ion-ios-calculator-outline"
                              style="font-size: 1.7em"></i><span
                              class='bottomTooltiptext tpActionTooltip'
                              style="font-size: 13px !important;width: 150px !important;">Build your formula</span></span></span>
                          </div>
                          <div class="medium-2 columns">
                            <button (click)="createCustomRate(tempCustomRate, index)" class="button tiny float-left"
                                    style="margin-right: 10px; margin-top: 10px;">Add
                            </button>
                            <button (click)="removeTempCustomRate(index)" class="button tiny float-left"
                                    style="margin-top: 10px;">Cancel
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div *ngIf="showCostLines" class="reports tabs-panel is-active p-3" id="fees" style="padding: 0;" style="background: #fefefe;margin-bottom: 10px;">
                      <div class="row">
                        <div class="column medium-12 large-12">
                            <span (click)="showCostLines = false" class="pointer float-right">
                              <i class="icon ion-ios-close-outline manage-strategy-icon"></i>
                            </span>
                        </div>
                      </div>
                      <app-fee-lines (onCreationOrUpdateOfCostLine)="refreshCostLines()" [associatedWith]="associatedWith" [clientTaxPlan]="clientTaxPlan"
                                     [clientUserId]="clientUserId" [costLines]="costLines"
                                     [freezPlan]="freezPlan"
                                     [planYearFilter]="planYearFilter" [taxStrategyId]="taxStrategyId"
                                     [userReadOnly]="userReadOnly"></app-fee-lines>
                    </div>
                    <div *ngIf="showNotes" class="reports tabs-panel is-active p-3 position-relative" id="notes" style="padding: 0;"
                         style="background: #fefefe;margin-bottom: 10px;">
                      <div class="row">
                        <div class="column medium-12 large-12 ">
                            <span (click)="showNotes = false" class="pointer float-right position-absolute end-0 top-0">
                              <i class="icon ion-ios-close-outline manage-strategy-icon"></i>
                            </span>
                        </div>
                      </div>
                      <div class="row">
                        <div (click)="showAdditionalInfo('notes')" class="column medium-4">
                          <div class="pointer notes-container">
                            <a href="javascript:void (0)" style="text-decoration: underline;">Internal Notes of this plan</a>
                          </div>
                        </div>
                        <div (click)="showAdditionalInfo('disclaimer')" class="column medium-4">
                          <div class="pointer notes-container"><a href="javascript:void (0)" style="text-decoration: underline;">Client Disclaimer</a></div>                          
                        </div>
                        <!-- <div (click)="showAdditionalInfo('report_customization')" class="column medium-4">
                          <div class="pointer notes-container"><a href="javascript:void (0)" style="text-decoration: underline;">Report Customization</a></div>
                        </div> -->
                      </div>
                      
                    </div>
                    <div *ngIf="showCashflow" class="reports tabs-panel is-active" id="cashflow" style="padding: 0;"
                         style="background: #fefefe;margin-bottom: 10px;">
                      <div class="row">
                        <div class="column medium-12 large-12">
                            <span (click)="showCashflow = false" class="pointer float-right">
                              <i class="icon ion-ios-close-outline manage-strategy-icon"></i>
                            </span>
                        </div>
                      </div>
                      <app-cashflow-lines (onCreationOrUpdateOfCashflow)="refreshCashflowLines()" [cashflowLines]="cashflowLines" [cashflowStrategies]="cashflowStrategies"
                                          [client]="client" [freezPlan]="freezPlan"
                                          [taxStrategyId]="taxStrategyId"
                                          [thirdPartiesList]="thirdPartiesList"
                                          [userReadOnly]="userReadOnly"></app-cashflow-lines>
                    </div>
                  </div>
                </div>
                <div class="column medium-12 tabs-content" style="padding: 0;">
                  <div
                    *ngIf="hasStrategies && clientTaxPlan.strategies && scenariosExist && !freezPlan && !userReadOnly"
                    style="margin-top: 10px; font-size: 15px;">
                    <app-plan-strategies (onStrategyAction)="triggerOnRefreshPlan($event)" 
                                         [allAssociatedData]="allAssociatedData" [allStateAssociatedData]="allStateAssociatedData"
                                         [allTaxStrategies]="allTaxStrategies"
                                         [clientTaxPlan]="clientTaxPlan" [clientUserId]="clientUserId"
                                         [client]="client"
                                         [clientsList]="clientsList" [currentPlan]="currentPlan"
                                         [filteredStrategies]="filteredStrategies" [fixedRatesArray]="fixedRatesArray"
                                         [isPaidPlan]="isPaidPlan" [planYearFilter]="planYearFilter"
                                         [tempCustomTaxRates]="tempCustomTaxRates"></app-plan-strategies>
                  </div>
                  <div *ngIf="scenariosExist && (freezPlan || userReadOnly)">
                    <div class="row no-hover">
                      <div class="column medium-12 large-12 tpiq-paginated-table">
                        <table style="margin-top: 0 !important;">
                          <thead>
                          <tr>
                            <th *ngFor="let column of columns" class="pointer">
                              {{column.title}}
                            </th>
                            <th class="pointer"></th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr *ngFor="let row of freezPlanStrategies">
                            <td *ngFor="let col of columns;let idx=index">
                              <span (click)="showStrategyInfo(row, col)" *ngIf="col.name === 'strategyName' && row[col.name]!='Total'"
                                    class="pointer"><i *ngIf="row['locked']"
                                                                            class="icon ion-ios-locked-outline"
                                                                            style="color: #F06459; margin-right: 5px;"></i>{{row[col.name]}}</span>
                              <span *ngIf="col.name === 'strategyName' && row[col.name]==='Total'" class="pointer"
                                    style="color: #14B5F0">{{row[col.name]}}</span>
                              <span *ngIf="col.name !== 'strategyName' && row[col.name]!='Total'"
                                    class="pointer">{{row[col.name]}}</span>
                            </td>
                            <td *ngIf="row['strategyName']!='Total'">
                              <span (click)="toggleStrategyRecurring()" *ngIf="row['recurring']"
                                    class='badge-tooltip'><a class='action'
                                                                           data-action='toggle-recurring'
                                                                           style="visibility: visible;position: relative;bottom: 6px;"><span
                                class="recurring-badge text-center">R</span><span
                                class='bottomTooltiptext tpActionTooltip'
                                style="min-width: 100px !important;max-width: 125px !important;">Task is marked recurring</span></a></span>
                              <span (click)="toggleTaskSinglePage(row)" *ngIf="row['taskId']" class='badge-tooltip'><a
                                class='action' data-action='task'
                                style="visibility: visible;position: relative;bottom: 6px;"><span class="task-badge text-center">T</span><span
                                class='bottomTooltiptext tpActionTooltip'
                                style="min-width: 100px !important;max-width: 125px !important;">Click to go to the associated task</span></a></span>
                              <span (click)="showStrategyNotesPopup(row)" *ngIf="row['notes']"><a
                                class='action comment-badge' data-action='notes'><i
                                class="material-icons strategy-action-icon mdl-badge last-activity" data-badge=''>short_text</i></a></span>
                              <span (click)="showStrategyNotesPopup(row)" *ngIf="!row['notes']"><a><i
                                class="material-icons strategy-action-icon" data-badge=''>short_text</i></a></span>
                            </td>
                            <td *ngIf="row['strategyName']=='Total'"></td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                  </div>
                  <div *ngIf="!scenariosExist">
                    <div class="row">
                      <div class="small-12 medium-12">
                        <div class="callout text-center">
                          <p>No plans found</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="isPaidPlan || userReadOnly" class="reports tabs-content" data-tabs-content="report-tabs"
               foundation>
            <div *ngIf="currentView == 'roi_dashboard'" class="reports tabs-panel is-active" id="dashboard"
                 style="padding: 0;">
              <div class="row" style="margin-top: 15px !important;">
                <div *ngIf="clientTaxPlan" class="medium-12 columns" style="padding: 0;">
                  <app-client-plan-report [associatedData]="allAssociatedData" [bgColor]="bgColor"
                                          [clientTaxplanData]="clientTaxPlan" [clientsList]="clientsList"
                                          [readOnly]="userReadOnly"
                                          [roiGraphFilter]="roiGraphFilterYear" [stateAssociatedData]="allStateAssociatedData"
                                          [taxPlanId]="taxStrategyId"
                                          [taxYear]="planYearFilter"
                                          [planYear]="taxPlanYear"></app-client-plan-report>

                </div>
              </div>
            </div>
          </div>
          <div *ngIf="isPaidPlan || userReadOnly" class="reports tabs-content" data-tabs-content="report-tabs"
               foundation>
            <div *ngIf="currentView == 'roi_presentation'" class="reports tabs-panel is-active" id="presentation"
                 style="padding: 0;">
              <app-roi-presentation [clientData]="client" [clientTaxplanData]="clientTaxPlan" [planYear]="taxPlanYear"
                                    [readOnly]="userReadOnly"></app-roi-presentation>
            </div>
          </div>
          <div class="reports tabs-content" data-tabs-content="report-tabs" foundation>
            <div *ngIf="currentView == 'tax_estimates' && clientTaxPlan && clientTaxPlan.id" class="reports tabs-panel is-active"
                 id="estimates" style="padding: 0;">
              <app-tax-estimates-inputs (triggerForRefreshPlan)="triggerOnRefreshPlan()" [allAssociatedData]="allAssociatedData" [associatedWithData]="associatedWith"
                                        [bgColor]="bgColor" [clientData]="client"
                                        [clientTaxplanData]="clientTaxPlan"
                                        [clientsList]="clientsList"
                                        [planYear]="taxPlanYear" [stateAssociatedWithData]="allStateAssociatedData"
                                        [strategiesList]="filteredStrategies"></app-tax-estimates-inputs>
            </div>
          </div>
          <div *ngIf="isPaidPlan || userReadOnly" class="reports tabs-content" data-tabs-content="report-tabs"
               foundation>
            <div *ngIf="currentView == 'cashflow_timeline' && clientTaxPlan && clientTaxPlan.id" class="reports tabs-panel is-active"
                 id="timeline" style="padding: 0;">
              <app-cashflow-timeline [clientTaxplanData]="clientTaxPlan"
                                     [planYear]="taxPlanYear"></app-cashflow-timeline>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<div *ngIf="reveal['duplicate-plan']">
  <div [ngClass]="{'tpiq-reveal': reveal['duplicate-plan']}" class="reveal-overlay">
  </div>
  <div [ngClass]="{'tpiq-reveal': reveal['duplicate-plan']}" class="reveal tax-strategy-reveal"
       style="padding: 0; border: none; width: 50%;">
    <div style="height: 50px; padding: 15px; color: #333333;">
      <span class="float-left">Duplicate Plan</span>
      <span (click)="hideReveal('duplicate-plan')" class="float-right pointer">X</span>
    </div>
    <div style="padding: 0 15px;">
      <hr style="margin: 0;"/>
    </div>
    <div class="body reveal-publish" style="padding: 15px;">
      <div class="row row-padding-reveal">
        <div class="medium-12 columns">
          <label>
            Enter name of new plan*:
            <input [(ngModel)]="duplicatePlanName" placeholder="Enter name" style="font-size: 1.0em !important;"
                   type="text"/>
          </label>
        </div>
        <div class="medium-6 columns">
          <label>
            Enter plan year*:
            <input [(ngModel)]="duplicatePlanYear" placeholder="2020" style="font-size: 1.0em !important;" type="text"/>
          </label>
        </div>
      </div>
      <div class="row">
        <div class="medium-12 columns row-padding-reveal">
          <button (click)="createDuplicate()" [disabled]="duplicatingPlan" class="button small float-right">Create</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="reveal['rename-plan']">
  <div [ngClass]="{'tpiq-reveal': reveal['rename-plan']}" class="reveal-overlay">
    <div (click)="stopPropagation($event)" [ngClass]="{'tpiq-reveal': reveal['rename-plan']}" class="reveal"
         style="padding: 0; border: none;">
      <div style="height: 50px; padding: 15px; color: #333333;">
        <span class="float-left">Rename Plan</span>
        <span (click)="hideReveal('rename-plan')" class="float-right pointer">X</span>
      </div>
      <div style="padding: 0 15px;">
        <hr style="margin: 0;"/>
      </div>
      <div class="body" style="padding: 15px;">
        <div class="row">
          <div class="medium-12 columns">
            <label>
              Enter name:
              <input [(ngModel)]="newPlanName" placeholder="Enter new name" type="text"/>
            </label>
          </div>
        </div>
        <div class="row">
          <div class="medium-12 columns">
            <button (click)="renamePlan()" class="button small float-right">Rename</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="reveal['strategyNotes']">
  <div [ngClass]="{'tpiq-reveal': reveal['strategyNotes']}" class="reveal-overlay">
  </div>
  <div [ngClass]="{'tpiq-reveal': reveal['strategyNotes']}" class="reveal tax-strategy-reveal"
       style="padding: 0; border: none; width: 85%;">
    <div style="height: 50px; padding: 15px; color: #333333;">
      <span class="float-left">{{currentNotesStrategy.strategyName}}</span>
      <span (click)="hideReveal('strategyNotes')" class="float-right pointer">X</span>
    </div>
    <div style="padding: 0 15px;">
      <hr style="margin: 0;"/>
    </div>
    <div class="body" style="padding: 15px;">
      <div class="row">
        <div class="medium-12 columns">
          <label>
            Notes for implementing {{currentNotesStrategy.strategyName}} :
            <textarea [(ngModel)]="currentNotesStrategy.notes" placeholder="Write your notes here."
                      style="height: 100px; resize: none;"></textarea>
          </label>
        </div>
      </div>
      <div class="row">
        <div class="medium-12 columns">
          <button (click)="updateNotesForStrategy()" [disabled]="freezPlan || userReadOnly"
                  class="button small float-right">Update
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="reveal['planInfo']">
  <div [ngClass]="{'tpiq-reveal': reveal['planInfo']}" class="reveal-overlay">
  </div>
  <div [ngClass]="{'tpiq-reveal': reveal['planInfo']}" class="reveal tax-strategy-reveal"
       style="padding: 0; border: none; width: 85%;">
    <div style="height: 50px; padding: 15px; color: #333333;">
      <span class="float-left">Additional Information</span>
      <span (click)="hideReveal('planInfo')" class="float-right pointer">X</span>
    </div>
    <div style="padding: 0 15px;">
      <hr style="margin: 0;"/>
    </div>
    <div class="body" style="padding: 15px;">
      <div *ngIf="clientPlanInfoType == 'notes'" class="row">
        <div class="medium-12 columns">
          <label>
            Internal notes about this plan:
            <div [(froalaModel)]="clientTaxPlan.description" [froalaEditor]="editorOptions"
                 style="border: 1px solid #cacaca;"></div>
          </label>
        </div>
      </div>
      <div *ngIf="clientPlanInfoType == 'disclaimer'" class="row">
        <div class="medium-12 columns">
          <label>
            Client Disclaimer:
            <div [(froalaModel)]="clientTaxPlan.disclaimer" [froalaEditor]="disclaimerEditorOptions"
                 style="border: 1px solid #cacaca;"></div>
          </label>
        </div>
      </div>
      <!-- <div *ngIf="clientPlanInfoType == 'report_customization'" class="row">
        <div class="medium-12 columns">
          <label>
            Why this applies to you:
            <div [(froalaModel)]="clientTaxPlan.reportCustomization" [froalaEditor]="reportEditorOptions"
                 style="border: 1px solid #cacaca;"></div>
          </label>
        </div>
      </div> -->
      <div class="row" style="margin-top: 10px;">
        <div class="medium-12 columns">
          <button (click)="updateClientStrategyDisclaimer()" [disabled]="freezPlan || userReadOnly"
                  class="button small float-right">Update
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="reveal['extraOptions']">
  <div [ngClass]="{'tpiq-reveal': reveal['extraOptions']}" class="reveal-overlay">
  </div>
  <div [ngClass]="{'tpiq-reveal': reveal['extraOptions']}" class="reveal tax-strategy-reveal"
       style="padding: 0; border: none; width: 50%;">
    <div style="height: 50px; padding: 15px; color: #333333;">
      <span class="float-left">Note</span>
      <span (click)="hideReveal('extraOptions')" class="float-right pointer">X</span>
    </div>
    <div style="padding: 0 15px;">
      <hr style="margin: 0;"/>
    </div>
    <div class="body reveal-publish d-flex align-items-center justify-content-center" style="height: 20vh;">
      Hitting your browsers soon.
    </div>
  </div>
</div>

<div *ngIf="reveal['publishtoggle']">
  <div [ngClass]="{'tpiq-reveal': reveal['publishtoggle']}" class="reveal-overlay">
  </div>
  <div [ngClass]="{'tpiq-reveal': reveal['publishtoggle']}" class="reveal tax-strategy-reveal"
       style="padding: 0; border: none; width: 50%;">
    <div style="height: 50px; padding: 15px; color: #333333;">
      <span class="float-left">Publish/Unpublish</span>
      <span (click)="hideReveal('publishtoggle')" class="float-right pointer">X</span>
    </div>
    <div style="padding: 0 15px;">
      <hr style="margin: 0;"/>
    </div>
    <div class="body reveal-publish" style="padding: 15px;">
      <ng-template [ngIf]="clientTaxPlan.status !== 'publish'">
        <div class="row row-padding-reveal">
          <div class="small-12 medium-12">
            <span>Which version of the ROI would you like to publish for <span
              style="font-weight: 600;color: #44b6e8">{{clientTaxPlan.name}}</span>?</span>
          </div>
        </div>
        <div class="row row-padding-reveal row-padding-left">
          <span class="float-left">
            <input [(ngModel)]="publishCategoryType" class="input-checkbox" type="checkbox"/>
          </span>
          <span class="float-left text-wrap">Category</span>
        </div>
        <div class="row row-padding-reveal row-padding-left">
          <span class="float-left">
            <input [(ngModel)]="publishStrategyType" class="input-checkbox" type="checkbox"/>
          </span>
          <span class="float-left text-wrap">Strategy</span>
        </div>
        <div class="row row-padding-reveal row-padding-left">
          <span class="float-left">
            <input [(ngModel)]="publishRelatedPartyType" class="input-checkbox" type="checkbox"/>
          </span>
          <span class="float-left text-wrap">Related Party</span>
        </div>
        <div class="row row-padding-reveal float-right">
          <button (click)="publishStrategy('publish')" class="button small">PUBLISH</button>
        </div>
      </ng-template>
      <ng-template [ngIf]="clientTaxPlan.status == 'publish'">
        <div class="row row-padding-reveal">
          <div class="small-12 medium-12">
            <span>Which version of the ROI would you like to publish for <span
              style="font-weight: 600;color: #44b6e8">{{clientTaxPlan.name}}</span>?</span>
          </div>
        </div>
        <div class="row row-padding-reveal row-padding-left">
          <span class="float-left">
            <input [(ngModel)]="unpublishValues.strategy" class="input-checkbox" type="checkbox"/>
          </span>
          <span class="float-left text-wrap">Strategy</span>
        </div>
        <div class="row row-padding-reveal row-padding-left">
          <span class="float-left">
            <input [(ngModel)]="unpublishValues.category" class="input-checkbox" type="checkbox"/>
          </span>
          <span class="float-left text-wrap">Category</span>
        </div>
        <div class="row row-padding-reveal row-padding-left">
          <span class="float-left">
            <input [(ngModel)]="unpublishValues.relatedParty" class="input-checkbox" type="checkbox"/>
          </span>
          <span class="float-left text-wrap">Related Party</span>
        </div>
        <div class="row row-padding-reveal row-padding-left">
          <span class="float-left text-wrap">Note: If no option is selected, plan will not be published.</span>
        </div>
        <div class="row row-padding-reveal float-right">
          <button (click)="unpublishStrategy('publish')" class="button small" style="margin-right: 5px;">Change Views
          </button>
          <button (click)="unpublishStrategy('unpublish')" class="button small">Unpublish</button>
        </div>
      </ng-template>
    </div>
  </div>
</div>


<div *ngIf="reveal['checklist']">
  <div (click)="hideReveal('checklist')" [ngClass]="{'tpiq-reveal': reveal['checklist']}" class="reveal-overlay">
  </div>
  <div [ngClass]="{'tpiq-reveal': reveal['checklist']}" class="reveal tax-strategy-reveal" style="width: 50%;">
    <div style="height: 50px; padding: 15px; color: #333333;">
      <span class="float-left">Checklist</span>
      <span (click)="hideReveal('checklist')" class="float-right pointer">X</span>
    </div>
    <div style="padding: 0 15px;">
      <hr style="margin: 0;"/>
    </div>

    <div class="body" style="padding: 15px;">
      <div *ngIf="!popupChecklistObj" class="row">
        <div class="medium-12 columns text-center">
          No checklist configured for this strategy.
        </div>
      </div>
      <div *ngIf="popupChecklistObj" class="row add-accordion workflow">
        <div class="medium-12 columns text-center">
          <div class="row workflow-status">
            <div class="small-12 medium-12 columns selectedValues">
              <label class="head-label">
                <span class="head-name head-quote" style="text-transform: none">Drag and drop to sort Checklist & Tick mark to make Checklist Mandatory</span>
              </label>
              <ul class="sortableChecklist drilldown-column status-column sortable-status"
                  style="width: 100%; margin-right: 6rem;">
                <li *ngFor="let value of popupChecklistObj.checklists;let i = index" [ngClass]="value.editingName ? 'input-status-edit' : 'ui-state-default' "
                    class="status-close" style="clear: both">
                  <span style="display: none">{{value.id}}</span>
                  <span [hidden]="value.editingName" class="pointer checklist-checkbox float-left">
                    <input [(ngModel)]="value.mandatory" [ngModelOptions]="{standalone: true}" class="check-icon"
                           type="checkbox">
                  </span>
                  <span [hidden]="value.editingName" class="fix-color">{{value.name}}</span>

                  <input [(ngModel)]="value.tempName" [hidden]="!value.editingName" [ngModelOptions]="{standalone: true}"
                         style="height: 25px; width: 90%; float: left;" type="text"/>
                  <i (click)="updateChecklist($event, value)"
                     [hidden]="!value.editingName" class="ion-ios-checkmark-outline save-row-icon float-left"
                     style="font-size: 21px; margin-left: 5px;"></i>
                  <i (click)="stopEditingName($event, value)"
                     [hidden]="!value.editingName" class="icon ion-ios-close-outline manage-strategy-icon float-left"
                     style="font-size: 21px; margin-left: 5px; color: #878787;"></i>

                  <span (click)="removeCheckListValue(popupChecklistObj.checklists, i)" [hidden]="value.editingName"
                        class="pointer checklist-remove float-right">
                    <i class="icon ion-close-round workflow-font"></i>
                  </span>
                  <span (click)="editChecklist($event, popupChecklistObj.checklists, i, value)" [hidden]="value.editingName"
                        class="pointer checklist-remove float-right">
                    <i class="icon ion-edit ion-close-round workflow-font"></i>
                  </span>
                </li>
              </ul>
            </div>
          </div>
          <div class="row">
            <div class="medium-12 columns">
              <button (click)="saveChecklist()" class="button small float-right">Update</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="reveal['columnDescriptions']">
  <div (click)="hideReveal('columnDescriptions')" [ngClass]="{'tpiq-reveal': reveal['columnDescriptions']}"
       class="reveal-overlay">
  </div>
  <div [ngClass]="{'tpiq-reveal': reveal['columnDescriptions']}" class="reveal tax-strategy-reveal" style="width: 90%;">
    <div class="header strategy-header">
      <span class="float-left">Plan table descriptions</span>
      <span (click)="hideReveal('columnDescriptions')" class="float-right pointer">X</span>
    </div>
    <div class="body table-descriptions">
    </div>
  </div>
</div>

<div *ngIf="reveal['fromulaCalculator']">
  <app-formula-builder (buildAssociatedObject)="buildAssociatedObject()" (onHideReveal)="hideReveal('fromulaCalculator')"
                       (onProgpageCustomRate)="propageCustomRateChange($event)" (onUpdateTaxRatesInFormula)="updateTaxRatesInFormula()"
                       (refreshTableData)="refreshTableData()" (triggerCloseAddCustomRateInStrategyPage)="triggerCloseAddCustomRateInStrategyPage($event)"
                       (triggerCloseEditCustomRate)="triggerCloseEditCustomRate($event)"
                       (triggerRecalcAndUpdatePlan)="triggerRecalcAndUpdatePlan($event)"
                       [actionType]="'create'"
                       [addingCustomRatesArray]="tempCustomTaxRates"
                       [allAssociatedData]="allAssociatedData"
                       [associatedWith]="associatedWith"
                       [clientTaxPlan]="clientTaxPlan"
                       [customRate]="tempCustomRateObject"
                       [fixedRatesArray]="fixedRatesArray"
                       [indexOfTempCustomObj]="indexOfTempCustomRateObject"
                       [isCustomRateEdit]="isCustomRateEdit"></app-formula-builder>
</div>

<div *ngIf="reveal['closePeriod']">
  <div [ngClass]="{'tpiq-reveal': reveal['closePeriod']}" class="reveal-overlay">
  </div>
  <div [ngClass]="{'tpiq-reveal': reveal['closePeriod']}" class="reveal tax-strategy-reveal"
       style="padding: 0; border: none; width: 40%;">
    <div style="height: 50px; padding: 15px; color: #333333;">
      <span class="float-left">Confirmation</span>
      <span (click)="hideReveal('closePeriod')" class="float-right pointer">X</span>
    </div>
    <div style="padding: 0 15px;">
      <hr style="margin: 0;"/>
    </div>
    <div class="body reveal-publish" style="padding: 15px;">
      <div class="row row-padding-reveal">
        <div class="small-12 medium-12">
          <span>This plan will be archived and rolled forward to next year. Would you like to continue?</span>
        </div>
        <div *ngIf="showPlanNameForNewPlan" class="small-12 medium-6" style="margin-top: 10px;">
          <label>
            Enter name of new plan:
            <input [(ngModel)]="closeYearPlanName" placeholder="Enter name" type="text"/>
          </label>
        </div>
        <div *ngIf="showPlanNameForNewPlan && showPlanNameValidationMessage" class="small-12 medium-12">
          <span style="font-size: 12px;color: #F16459;font-family: Poppins-Regular;  font-weight: 600;">Plan Name is mandatory</span>
        </div>
      </div>
      <div class="row-padding-reveal text-right">
        <button (click)="showCloseYearPlanName()" *ngIf="!showPlanNameForNewPlan" class="button small">Continue</button>
        <button (click)="freezeOrUnfreezePlan('archive', closeYearPlanName,true)" *ngIf="showPlanNameForNewPlan"
                [disabled]="closingPeriodPlan"
                class="button small">Submit
        </button>
        <button (click)="hideReveal('closePeriod')" *ngIf="!showPlanNameForNewPlan" class="button small"
                style="background: #f1645a !important;">No
        </button>
      </div>
    </div>
  </div>
</div>

<div *ngIf="reveal['showTemplates']">
  <div [ngClass]="{'tpiq-reveal': reveal['showTemplates']}" class="reveal-overlay">
  </div>
  <div [ngClass]="{'tpiq-reveal': reveal['showTemplates']}" class="reveal tax-strategy-reveal"
       style="padding: 0; border: none; width: 80%;">
    <div style="height: 50px; padding: 15px; color: #333333;">
      <span class="float-left">Templates</span>
      <span (click)="hideReveal('showTemplates')" class="float-right pointer">X</span>
    </div>
    <div style="padding: 0 15px;">
      <hr style="margin: 0;"/>
    </div>
    <div class="body reveal-publish" style="padding: 15px;">
      <div>
        <app-view-template (triggerUseTemplate)="triggerUseTemplate($event)" [allAssociatedData]="allAssociatedData"
                           [strategiesList]="allTaxStrategies"></app-view-template>
      </div>
    </div>
  </div>
</div>

<div *ngIf="reveal['useTemplate']">
  <div [ngClass]="{'tpiq-reveal': reveal['useTemplate']}" class="reveal-overlay">
  </div>
  <div [ngClass]="{'tpiq-reveal': reveal['useTemplate']}" class="reveal tax-strategy-reveal"
       style="padding: 0; border: none; width: 80%;">
    <div style="height: 50px; padding: 15px; color: #333333;">
      <span class="float-left">{{useTemplateData.templateName || 'Use Template'}}</span>
      <span (click)="hideReveal('useTemplate')" class="float-right pointer">X</span>
    </div>
    <div style="padding: 0 15px;">
      <hr style="margin: 0;"/>
    </div>
    <div class="body reveal-publish" style="padding: 15px;max-height: 75vh;overflow: auto;">
      <div *ngIf="useTemplateData">
        <app-use-template (triggerApplyTemplate)="triggerApplyTemplate()" [allAssociatedData]="allAssociatedData" [clients]="clientsList"
                          [planYear]="planYearFilter" [stateAssociatedData]="allStateAssociatedData"
                          [taxPlanId]="taxStrategyId"
                          [template]="useTemplateData"></app-use-template>
      </div>
    </div>
  </div>
</div>

<div *ngIf="reveal['morePlanAttachments']">
  <div [ngClass]="{'tpiq-reveal': reveal['morePlanAttachments']}" class="reveal-overlay">
  </div>
  <div [ngClass]="{'tpiq-reveal': reveal['morePlanAttachments']}" class="reveal tax-strategy-reveal"
       style="padding: 0; border: none; width: 85%;">
    <div style="height: 50px; padding: 15px; color: #333333;">
      <span class="float-left">Plan Attachments (Beta)</span>
      <span (click)="hideReveal('morePlanAttachments')" class="float-right pointer">X</span>
    </div>
    <div style="padding: 0 15px;">
      <hr style="margin: 0;"/>
    </div>
    <div class="body reveal-publish" style="padding: 15px;height: 80vh;">
      <div class="d-flex">
        <button (click)="showInfoPopup()" class="alignt-items-end button small">Upload</button>
        <input (change)="startUpload($event)" [uploader]="uploader" accept=".pdf,image/*" class="show-for-sr" id="planFileUpload"
               multiple ng2FileSelect type="file" value="null"/>
        <div class="notes-wrapper">
          <div class="bold notes">Notes:</div>
          <div>
            <span class="bold head">Document Upload: </span>
            <span class="text">Please upload your 1040 tax forms in PDF format only. Ensure that all non-tax-related pages are excluded and any sensitive information on the 1040 form is properly redacted before uploading.</span>
          </div>
          <div>
            <span class="bold head">Processing Time: </span>
            <span class="text">Processing Time: Our OCR process typically completes within a few minutes. Feel free to continue using other features of our software while you wait, and we'll notify you as soon as your document is processed.</span>
          </div>
          <div>
            <span class="bold head">Tax Strategies: </span>
            <span class="text">After your document is processed, we will provide personalized tax strategy suggestions tailored to the information from your uploaded 1040 form.</span>
          </div>
        </div>
      </div>
      <div class="d-flex files">
        <div class="files-list">
          <div *ngFor="let file of planFiles; let i=index;">
            <div class="file-list-item d-flex p-3">
              <div class="icon-wrapper">
                <i *ngIf="file.fileType == 'image'" class="fa fa-file-image-o image-icon"></i>
                <i *ngIf="file.fileType == 'pdf'" class="fa fa-file-pdf-o pdf-icon"></i>
              </div>
              <div class="file-tile ps-2 w-100">
                <div class="file-name">
                  <span (click)="downloadDocument(file, 'preview')" class="pointer">{{file.name}}</span>
                  <span class="float-right doc-download">
                    <i (click)="downloadDocument(file, 'download')"
                       class="icon ion-ios-cloud-download-outline float-right pointer"></i>
                  </span>
                  <span class="float-right doc-delete">
                    <i (click)="deleteDocumentFile(file, i)" class="icon ion-ios-trash float-right pointer"></i>
                  </span>
                  <span *ngIf="currentPlan == 'Paid'  || clientTaxPlan.paymentStatus == 'Paid'"
                        class="badge-tooltip float-right">
                    <i (click)="showOCRResponse(file)"
                       *ngIf="file.fileType == 'pdf' && file.ocrStatus && file.ocrResponse"
                       class="icon ion-android-bulb float-right pointer completed suggestion"></i>
                      <span class="leftTooltiptext">
                        View suggestions
                      </span>
                  </span>
                  <span *ngIf="currentPlan == 'Paid' || clientTaxPlan.paymentStatus == 'Paid'"
                        class="badge-tooltip float-right">
                    <i (click)="scanFile(file)"
                       *ngIf="file.fileType == 'pdf' && !file.ocrStatus" class="icon ion-android-bulb float-right pointer"></i>
                    <span class="leftTooltiptext">
                      Scan for suggestions
                    </span>
                  </span>
                </div>
                <div *ngIf="file.fileType == 'pdf' && file.ocrStatus && !file.ocrResponse"
                     class="d-flex justify-content-between align-items-center">
                  <mat-progress-bar class="progress-bar" mode="determinate"
                                    value="{{file.progress}}"></mat-progress-bar>
                  <span class="progress-indicator">{{file.progress}}%</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="file-content">
          <ng-template [ngIf]="currentFile.type == 'scanned'">
            <div [innerHTML]="strategyNotes" class="w-100 p-3"></div>
            <div [innerHTML]="currentFile.content" class="w-100 h-100 p-3"></div>
          </ng-template>
          <div *ngIf="currentFile.type == 'preview'" class="w-100 h-100 p-3">
            <iframe height="100" src="{{currentFile.fileUrl}}" width="100"></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="reveal['previewOfPlanDoc']">
  <div [ngClass]="{'tpiq-reveal': reveal['previewOfPlanDoc']}" class="reveal-overlay">
  </div>
  <div [ngClass]="{'tpiq-reveal': reveal['previewOfPlanDoc']}" class="reveal tax-strategy-reveal"
       style="padding: 0; border: none; width: 80%;">
    <div style="height: 50px; padding: 15px; color: #333333;">
      <span class="float-left">Preview of Document</span>
      <span (click)="hideReveal('previewOfPlanDoc')" class="float-right pointer">X</span>
    </div>
    <div style="padding: 0 15px;">
      <hr style="margin: 0;"/>
    </div>
    <div class="body reveal-publish" style="padding: 15px;max-height: 80vh;overflow-y: scroll;">
      <div *ngIf="viewFile">
        <app-tpiq-file-viewer [filename]="viewFile.name" [id]="viewFile.id"
                              [url]="viewFile.viewDocContentURL"></app-tpiq-file-viewer>
      </div>
    </div>
  </div>
</div>

<div [hidden]="!reveal['returnUploadDisclaimer']">
  <div [ngClass]="{'tpiq-reveal': reveal['returnUploadDisclaimer']}" class="reveal-overlay">
  </div>
  <div [ngClass]="{'tpiq-reveal': reveal['returnUploadDisclaimer']}" class="reveal tax-strategy-reveal"
       style="padding: 0; border: none; width: 85%;">
    <div style="height: 50px; padding: 15px; color: #333333;">
      <span class="float-left">Upload returns Disclaimer</span>
      <span (click)="hideReveal('returnUploadDisclaimer')" class="float-right pointer">X</span>
    </div>
    <div style="padding: 0 15px;">
      <hr style="margin: 0;"/>
    </div>
    <div class="body reveal-publish" style="padding: 15px;max-height: 80vh;overflow-y: scroll;">
      <div class="row">
        <div class="medium-12 columns">
          <p>
            To ensure the privacy and security of sensitive data, it is important to redact any confidential information
            before uploading documents to TaxPlanIQ. Follow these steps to properly redact sensitive data:
          </p>
          <p>1. Open the document or file containing sensitive information, using a reliable document editor like Adobe
            Acrobat DC. We recommend Redactable <a href="https://www.redactable.com/?via=48d670"
                                                   target="_blank">here</a>.</p>
          <p>2. Identify and review the data that needs to be redacted, such as names, addresses, social security
            numbers, or financial account numbers.</p>
          <p>3. Select/Search the sensitive information and apply the redaction tool to black out or remove it
            completely.</p>
          <p>4. Check the document to ensure that all sensitive data has been properly redacted, including headers,
            footers, and any hidden or embedded information.</p>
          <p>5. Save the redacted document with a new filename to preserve the original file.</p>
          <p>6. For scanned documents or image files, use image editing software to manually black out or remove
            sensitive information, and save the edited image with a new filename.</p>
          <p>7. Once the redaction is complete, you can safely upload the document to TaxPlanIQ or any other platform,
            knowing that the confidential information is protected.</p>
          <p>
            It is your responsibility to take necessary precautions and redact sensitive information properly before
            uploading it online. While TaxPlanIQ provides a secure platform, we do not assume responsibility for the
            handling or protection of sensitive data. Users are solely responsible for ensuring the privacy and security
            of any confidential information they upload or share on the platform.
          </p>
        </div>
        <div class="medium-12 columns text-right mt-2 mb-2">
          <label (click)="hideReveal('returnUploadDisclaimer')" class="pointer"
                 for="planFileUpload"
                 style="display: initial;color: #FFFFFF;border-radius: 6px !important;padding: 0.4em 0.8em;font-size: 0.9rem;background-color: #1570EF;">Ok</label>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- RAP Edit Mode Modal -->
<div *ngIf="reveal['openRapEdit']">
  <div class="reveal-overlay tpiq-reveal" [style.display]="'block'">
  </div>
  <div [ngClass]="{'tpiq-reveal': reveal['openRapEdit'], 'rap-maximized': isRapMaximized}" 
       class="reveal tax-strategy-reveal"
       [style.display]="'block'"
       [style.width]="isRapMaximized ? 'calc(100vw - 20px)' : '83%'"
       [style.height]="isRapMaximized ? 'calc(100vh - 20px)' : 'auto'"
       [style.top]="isRapMaximized ? '10px' : '25px'"
       [style.left]="'50%'"
       [style.transform]="'translateX(-50%)'"
       [style.max-height]="isRapMaximized ? 'calc(100vh - 20px)' : 'calc(100vh - 50px)'"
       style="padding: 0; border: none;">
    <div style="padding: 15px; color: #333333; display: flex; justify-content: flex-end; align-items: center; gap: 10px;">
      <i class="material-icons pointer" 
         [title]="isRapMaximized ? 'Restore' : 'Maximize'"
         (click)="toggleRapMaximize()"
         style="font-size: 20px; cursor: pointer; padding: 0 2px;">
        {{isRapMaximized ? 'fullscreen_exit' : 'fullscreen'}}
      </i>
      <span (click)="closeRapEditModal()" class="pointer" style="font-size: 20px; cursor: pointer; line-height: 1;">X</span>
    </div>
    <div class="body" style="padding: 15px;">
      <app-dashboard-upload-create-plan 
        [clientId]="rapEditClientId"
        [draftPlanId]="rapEditPlanId"
        [planName]="rapEditPlanName"
        [isReviewPlan]="true"
        [forceRapMode]="true"
        [questionnaireTrack]="0"
        [isRapMaximized]="isRapMaximized"
        [ocrStatus]="'OCR Done'"
        [tabToLand]="'clientInfo'"
        (onCancelCreationOfStrategy)="closeRapEditModal()"
        (onCommitSuccess)="handleCommitSuccess($event)"
        (openViewJsonPopup)="reveal['viewJson'] = true"
        (ocrDataReceived)="handleOcrData($event)"
        (updateQuestionarieData)="handleQuestionarieData($event)"
        (openViewQuestionariePopup)="reveal['viewQuestionarieDetails'] = true">
      </app-dashboard-upload-create-plan>
    </div>
  </div>
</div>
<div *ngIf="reveal['viewJson']">
  <div [ngClass]="{'tpiq-reveal': reveal['viewJson']}" class="reveal tax-strategy-reveal" style="padding: 0; border: none; width: 83%; z-index: 1100; height: 100%; max-height: calc(100vh - 50px);">
    <div style="padding: 15px; color: #333333;">
      <span (click)="hideReveal('viewJson')" class="float-right pointer">X</span>
    </div>
    <div class="body" style="padding: 15px;  max-height: 90vh; overflow-y: auto" >
     <div *ngIf="ocrViewJsonData">
      <h6>OCR Data:</h6>
      <pre>{{ ocrViewJsonData ? (ocrViewJsonData | json) : 'No data yet' }}</pre>
    </div>
    <div *ngIf="!ocrViewJsonData">
      <h6>OCR Data Not Found</h6>
    </div>
  </div>
</div>
</div>
<div *ngIf="reveal['viewQuestionarieDetails']">
  <div [ngClass]="{'tpiq-reveal': reveal['viewQuestionarieDetails']}" class="reveal tax-strategy-reveal" style="padding: 0; border: none; width: 83%; z-index: 1100; height: 100%; max-height: calc(100vh - 50px);">
    <div style="padding: 15px; color: #333333;">
      <span (click)="hideReveal('viewQuestionarieDetails')" class="float-right pointer">X</span>
    </div>
    <div class="body" style="padding: 15px;  max-height: 90vh; overflow-y: auto" >
     <div>
      <h6>OCR data from last knoli session:</h6>
      <pre>{{ questionarieData && questionarieData.ocrData ? (questionarieData.ocrData | json) : 'New Json not avaiable as Questionarie details not submitted' }}</pre>
      <a *ngIf="questionarieData && questionarieData.chatId" href="{{currentEnvironment.KNOLLI_CHAT_URL}}/admin/workspaces/1505/copilots/1523/edit/conversations/{{questionarieData.chatId}}" target="_blank">Click here to view coversation details on knolli</a>
    </div>
  </div>
</div>
</div>
